export const buildApiEndpoint = (basePath, params) => {
    const query = new URLSearchParams(params).toString();
    return `${basePath}?${query}`;
};